import { Controller, Application } from "stimulus"
import Autonumeric from "autonumeric";
import getCsrfToken from "../utils/csrf";

export default class extends Controller {
    static targets = [
        "rentPerDay",
        "rentPerWeek",
        "rentPerMonth",
        "option",
        "instantBooking",
        "instantBookingTrue",
        "instantBookingFalse",
        "notificationCloseIcon"
    ]

    static values = {
        url: String,
        enabled: Boolean
    }

    connect() {
        if (this.hasRentPerDayTarget) {
            this.fillPrices(this.rentPerDayTarget)
        }
        if (this.hasRentPerWeekTarget) {
            this.fillPrices(this.rentPerWeekTarget)
        }
        if (this.hasRentPerMonthTarget) {
            this.fillPrices(this.rentPerMonthTarget)
        }
    }

    onSubmitPhotosForm(event) {
        this.checkFiles(event)
    }

    checkFiles(event) {
        const files = document.querySelector('.files .template-download');
        const photosError = document.querySelector('#modal__photos_form').dataset.photoserror;
        if (!files) {
            alert(photosError);
            event.preventDefault();
        }
    }

    optionChanged(event) {
        this.fillPrices(event.target)
    }

    handleNotificationClose() {
        this.notificationCloseIconTarget.style.display = "none";
    }

    enable() {
        fetch(this.urlValue, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/html",
                "X-CSRF-Token": getCsrfToken()
            },
            body: JSON.stringify({
                render_target: '#listing_edit',
                v2_edit: true
            })
        }).then(response => {
            const redirectTo = response.headers.get('redirect-to');
            if (redirectTo) {
                window.location.href = redirectTo;
            }

            if ([400, 500].includes(response.status)) return;

            const renderTarget = response.headers.get('render-target');

            return response.text().then(html => {
                Turbolinks.clearCache();

                if (renderTarget) {
                    const dstEl = document.querySelector(renderTarget);
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = html;

                    const srcEl = tempDiv.querySelector(renderTarget);

                    if (srcEl && dstEl) {
                        dstEl.innerHTML = srcEl.innerHTML;
                    }
                } else {
                    document.body.innerHTML = html;
                }

                Turbolinks.dispatch("turbolinks:load");
            });
        }).catch(error => {
            console.error("Fetch failed", error);
        });
    }

    advanceTypeChanged() {
        const selectedOption = this.optionTargets.find(radio => radio.checked)

        if (selectedOption && selectedOption.value === 'no_advance') {
            if (!this.instantBookingTarget.classList.contains('!hidden')) {
                this.instantBookingTrueTarget.checked = "false"
                this.instantBookingFalseTarget.checked = "true"
                this.instantBookingTarget.classList.add('!hidden');
            }
        } else {
            this.instantBookingTrueTarget.checked = "true"
            this.instantBookingFalseTarget.checked = "false"
            this.instantBookingTarget.classList.remove('!hidden');
        }
    }

    optionIntegerChanged(event) {
        let value = event.target.value;
        value = value.replace(/\D/g, '');
        let intValue = parseInt(value, 10);

        if (isNaN(intValue) || intValue < 1) {
            event.target.value = '';
        } else {
            event.target.value = intValue;
        }
    }

    fillPrices(target) {
        const pricesSection = document.getElementById("pricing_section");
        const decimalMark = pricesSection.dataset.a_dec;
        const thousandsSeparator = pricesSection.dataset.a_sep;

        const oldInput = target
        const input = document.createElement("input");
        input.className = oldInput.className;
        oldInput.parentNode.replaceChild(input, oldInput);

        input.id = oldInput.id;
        input.setAttribute("type", "text");
        input.setAttribute("name", oldInput.name);

        const PriceObj = new Autonumeric(input, {
            digitGroupSeparator: thousandsSeparator,
            decimalCharacter: decimalMark,
            minimumValue: 0,
            maximumValue: 2147483647
        });

        const price = target.value || '';
        input.value = price;
        PriceObj.set(price)
    }
}
